import BaseModel from "./BaseModel";
import Checkout from "./Checkout";

export default class CheckoutStatus extends BaseModel {

    static data_name = 'status';

    static newInstance(parent) {
        let instance = new this();
        instance.document_id = this.data_name;
        instance.parent = parent;
        instance.has_successful_payment = false;
        instance.is_process_complete = false;
        instance.message = "";
        instance.error_message = "";
        instance.has_error = false;
        return instance;
    }

    static async forCheckoutID(checkout_document_id){
        let checkout = new Checkout();
        checkout.document_id = checkout_document_id;
        let subcollection_document_id = this.data_name;
        return await this.subCollectionItemOf(checkout, subcollection_document_id);
    }
}